import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = ["id", "data-cy", "aria-expanded", "aria-controls"];
var _hoisted_3 = ["itemprop", "innerHTML"];
import { ref, watch } from "vue";
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
import BaseAccordionContent from "@vueEntry/UIKitComponents/Accordion/BaseAccordionContent.vue";
import BaseAccordionBtn from "@vueEntry/UIKitComponents/Accordion/BaseAccordionBtn.vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseAccordionItem',
  props: {
    title: {},
    id: {},
    active: {
      type: Boolean,
      "default": false
    },
    arrowWidth: {
      "default": 12
    },
    onContainerClickExpand: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["click", "accordionOpened", "accordionClosed", "update:accordionState"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var accordionOpen = ref(false);
    var props = __props;
    watch(accordionOpen, function (cur) {
      if (cur) emits("accordionOpened", props);else emits("accordionClosed", props);
      emits("update:accordionState", cur);
      accordionOpen.value = cur;
    });
    watch(function () {
      return props.active;
    }, function (cur) {
      accordionOpen.value = cur;
    }, {
      immediate: true
    });
    var toggleAccordion = function toggleAccordion() {
      accordionOpen.value = !accordionOpen.value;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(_ctx.$attrs['root-classes'])
      }, [!_ctx.$slots['custom_content'] && !_ctx.$slots['custom_btn'] && !_ctx.$slots['custom_accordion'] ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [_createElementVNode("button", {
        id: "accordion-title-".concat(_ctx.id),
        type: "button",
        "class": _normalizeClass(["tw-flex tw-items-center tw-justify-between tw-w-full tw-text-left tw-font-semibold tw-py-4 tw-px-5 tw-transition-colors tw-bg-white active:max-sm:tw-bg-w-cultured hover:sm:tw-bg-w-cultured", _ctx.$attrs['btn-classes']]),
        "data-cy": _ctx.$attrs['data-cy'],
        "aria-expanded": accordionOpen.value,
        "aria-controls": "accordion-text-".concat(_ctx.id),
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          toggleAccordion();
          emits('click');
        }, ["prevent", "stop"]))
      }, [_createElementVNode("span", {
        itemprop: _ctx.$attrs['itemprop'],
        innerHTML: _ctx.title
      }, null, 8 /* PROPS */, _hoisted_3), _createVNode(_unref(ArrowIcon), {
        "class": _normalizeClass(["tw-transition-transform motion-reduce:tw-transition-none tw-flex-shrink-0", [accordionOpen.value && '-tw-rotate-180', _ctx.$attrs['arrow-classes']]]),
        "arrow-classes": _ctx.$attrs['arrow-classes'],
        width: _ctx.arrowWidth,
        height: _ctx.arrowWidth
      }, null, 8 /* PROPS */, ["class", "arrow-classes", "width", "height"])], 10 /* CLASS, PROPS */, _hoisted_2)])) : (_ctx.$slots['custom_content'] || _ctx.$slots['custom_btn']) && !_ctx.$slots['custom_accordion'] ? (_openBlock(), _createBlock(BaseAccordionBtn, {
        key: 1,
        id: _ctx.id,
        "btn-wrapper-classes": _ctx.$attrs['btn-wrapper-classes'],
        "btn-classes": _ctx.$attrs['btn-classes'],
        "arrow-classes": _ctx.$attrs['arrow-classes'],
        "toggle-accordion": toggleAccordion,
        "on-container-click-expand": _ctx.onContainerClickExpand,
        "accordion-open": accordionOpen.value
      }, {
        custom_content: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "custom_content")];
        }),
        custom_btn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "custom_btn", {
            btnId: "btn-".concat(_ctx.id),
            isOpen: accordionOpen.value,
            toggleAccordion: toggleAccordion
          })];
        }),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["id", "btn-wrapper-classes", "btn-classes", "arrow-classes", "on-container-click-expand", "accordion-open"])) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "custom_accordion", {
        id: _ctx.id,
        isOpen: accordionOpen.value,
        toggleAccordion: toggleAccordion
      }, function () {
        return [_createVNode(BaseAccordionContent, {
          id: _ctx.id,
          "accordion-open": accordionOpen.value,
          "accordion-open-classes": _ctx.$attrs['accordion-open-classes'],
          "accordion-close-classes": _ctx.$attrs['accordion-close-classes'],
          "accordion-classes": _ctx.$attrs['accordion-classes']
        }, {
          custom_accordion_content: _withCtx(function () {
            return [_renderSlot(_ctx.$slots, "custom_accordion_content", {
              isOpen: accordionOpen.value
            })];
          }),
          "default": _withCtx(function () {
            return [_renderSlot(_ctx.$slots, "default", {
              isOpen: accordionOpen.value
            })];
          }),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["id", "accordion-open", "accordion-open-classes", "accordion-close-classes", "accordion-classes"])];
      })], 2 /* CLASS */);
    };
  }
}));